import { PolicyType } from '@practium/features/policy';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export interface UpdatePolicy {
	policyVersionId: string;
	title?: string;
	description?: string;
	content: string;
	effectiveDate: string;
	versionNumber: string;
	isActive: boolean;
	policyType: PolicyType;
}

export function useUpdatePolicy() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: UpdatePolicy) => {
			try {
				return (await api.post(`/management/policy-version/update`, data)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar o termo.');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['policies'] });
		},

        onError: (error) => {
            console.error('Erro ao atualizar o termo:', getApiErrorMessage(error, 'Erro ao atualizar o termo.'));
        },
	});
}
